import { render } from "./FlyAvatar.vue?vue&type=template&id=792ccce4"
import script from "./FlyAvatar.vue?vue&type=script&lang=js"
export * from "./FlyAvatar.vue?vue&type=script&lang=js"

import "./FlyAvatar.vue?vue&type=style&index=0&id=792ccce4&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__